import React, { Component } from "react";
import { Form } from "formsy-react-components";
import AbbreviatedMillionNumberFormat from "../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import PriceInMillions from "../../ui-building-blocks/numbers/PriceInMillions";
import { getRequest, postRequest, patchRequest } from "../../../api/ApiService";
import SweetAlert from "sweetalert-react";
import EventEmitter from "../../../services/event-emitter";
import { logError } from "../../../services/utils";
import NumberFormat from "react-number-format";
import styled from "styled-components";

const postProjectionsAPI = `${process.env.REACT_APP_API_URL}team/projections/`;

const ButtonsBlock = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2em;
`;

const BlockTitle = styled.h1`
  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  text-align: left;
`;

const Buttons = styled.div`
  text-align: right;
  width: 100%;

  button + button {
    margin-left: 10px;
  }
`;

const TableRow = styled.div`
  display: flex;
  align-items: center;

  ${p =>
    p.marginTop &&
    `
    margin-top: ${p.marginTop};
  `}
`;

const TableColumn = styled.div`
  width: 100%;

  ${p =>
    p.align &&
    `
    text-align: ${p.align};
  `}

  ${p =>
    p.marginLeft &&
    `
    margin-left: ${p.marginLeft};
  `}

  ${p =>
    p.fontSize &&
    `
    font-size: ${p.fontSize};
  `}
`;

const NumberFormatStyled = styled(NumberFormat)`
  border: 3px solid #e0e0e0;
  padding: 5px;
  font-size: 16px;
  text-align: center;
  outline: none;
  max-width: 100px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2px;
`;

const TotalBlock = styled.div`
  border: 3px solid #52c5cd;
  background: #52c5cd;
  padding: 5px;
  font-size: 16px;
  text-align: center;
  outline: none;
  max-width: 100px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2px;
  color: #fff;

  ${p =>
    p.light &&
    `
    color: rgb(51, 51, 51);
    border-color: transparent;
    background-color: rgba(82, 197, 205, 0.3);
  `}
`;

class ProjectionsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      year1: props.year1,
      year2: props.year2,
      year3: props.year3,
      loading: false,
      showAlert: false,
      alertText: "",
      currentRound: props.currentRound,
      afterSave: false,
      defaultValues: {
        units_sold: 200000,
        average_selling_price: 5,
        average_unit_costs: 3,
        other_operating_costs: 600000
      }
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  componentWillReceiveProps(nextProps) {
    if (
      (this.state.year1 !== nextProps.year1 ||
        this.state.year2 !== nextProps.year2 ||
        this.state.year3 !== nextProps.year3) &&
      (this.state.currentRound !== nextProps.currentRound ||
        this.state.afterSave === true)
    ) {
      this.setState({
        year1: nextProps.year1,
        currentRound: nextProps.currentRound,
        afterSave: false
      });
    }
  }

  componentDidMount() {
    this.eventemitter.on("ceo-show-modal", this.showModal);
    this.eventemitter.on("ceo-hide-modal", this.hideModal);
    this.eventemitter.on("ceo-force-update", this.rerender);
  }

  componentWillUnmount() {
    this.eventemitter.off("ceo-show-modal", this.showModal);
    this.eventemitter.off("ceo-hide-modal", this.hideModal);
    this.eventemitter.off("ceo-force-update", this.rerender);
  }

  rerender = () => {
    this.forceUpdate();
  };

  get isSaveDisabled() {
    if (this.props.tourMode === false) {
      return false;
    }

    return true;
  }

  hideModal = () => {
    this.props.hideModal();
  };

  showModalTour = () => {
    // do nothing there
  };

  showModal = () => {
    if (this.props.tourMode === true) {
      this.props.showModal();
    } else if (this.props.hasAccess === true) {
      this.props.showModal();
    } else {
      this.props.showRoleAlert();
    }
  };

  hideAlert = () => {
    this.setState({
      showAlert: false
    });
  };

  changeInputElement2 = (e, nonFormattedValue, formatValue, maxValue) => {
    const input = e.target;
    const value =
      (nonFormattedValue instanceof Object && nonFormattedValue.floatValue) ||
      parseFloat(nonFormattedValue);
    const key = input.name;

    this.changeInputElement(key, value, formatValue, maxValue);
    this.changeInputElement(
      key.replace("year1_", "year2_"),
      value,
      formatValue,
      maxValue
    );
    this.changeInputElement(
      key.replace("year1_", "year3_"),
      value,
      formatValue,
      maxValue
    );
  };

  changeInputElement = (key, value, formatValue, maxValue) => {
    let [year, ...param] = key.split("_");
    param = param.join("_");

    if (year in this.state) {
      let data = this.state[year];

      value = parseFloat(value, 10);
      if (isNaN(value)) {
        value = 0;
      }

      if (value < 0) {
        value = 0;
      }

      if (value > maxValue) {
        value = maxValue;
      }

      if (formatValue === true) {
        value *= 1000000;
      }

      data[param] = 0;
      this.setState(
        {
          [year]: data
        },
        () => {
          data[param] = value;

          this.setState({
            [year]: data
          });
        }
      );
    }
  };

  getInputElement = (year_number, key, formatValue, max_value) => {
    let year = year_number - this.props.year_number1 + 1;
    let name = `year${year}_${key}`;
    let value = this.getObjectValue(this.getObject(year), key);

    if (formatValue === true) {
      value /= 1000000;

      return (
        /*<Input
          {...this.inputProps}
          name={name}
          value={value}
          onChange={(key, value) => this.changeInputElement(key, value, formatValue, max_value)}
        />*/
        <NumberFormatStyled
          thousandSeparator=","
          decimalSeparator="."
          decimalPrecision={2}
          name={name}
          value={value}
          onChange={(e, value) =>
            this.changeInputElement2(e, value, formatValue, max_value)
          }
          suffix=" M"
        />
      );
    }

    return (
      <NumberFormatStyled
        prefix="$"
        thousandSeparator=","
        decimalSeparator="."
        decimalPrecision={2}
        name={name}
        value={value}
        onChange={(e, value) =>
          this.changeInputElement2(e, value, formatValue, max_value)
        }
      />
    );
  };

  getRequest = (url, method) => {
    if (method === "patch") {
      return patchRequest(url);
    } else if (method === "get") {
      return getRequest(url);
    }

    return postRequest(url);
  };

  getProjectionsUrl = object_id => {
    let url = postProjectionsAPI;
    let method = "post";
    if (object_id > 0) {
      url += object_id + "/";
      method = "patch";
    }

    return [url, method];
  };

  getProjections = object_id => {
    let [url, method] = this.getProjectionsUrl(object_id);
    return this.getRequest(url, method);
  };

  submitData = () => {
    if (this.props.tourMode === true) {
      // do nothing there
      return;
    }

    this.setState({
      loading: true
    });
    this.updateYear1();
  };

  updateYear1 = () => {
    this.updateYear("year1", this.updateYear2);
  };

  updateYear2 = () => {
    this.updateYear("year2", this.updateYear3);
  };

  updateYear3 = () => {
    this.updateYear("year3", this.closeModal);
  };

  closeModal = () => {
    this.setState(
      {
        loading: false,
        afterSave: true
      },
      () => {
        this.props.onSave();
        this.props.hideModal();
      }
    );
  };

  updateYear = (year, callback) => {
    let data = this.getObject(year);
    let units_sold = this.getObjectValue(data, "units_sold");
    let average_selling_price = this.getObjectValue(
      data,
      "average_selling_price"
    );
    let average_unit_costs = this.getObjectValue(data, "average_unit_costs");

    if (units_sold < 1) {
      this.setState({
        loading: false,
        alertText: "Units cannot be lower then 1",
        showAlert: true
      });
      return;
    }

    if (average_selling_price < 0.1) {
      this.setState({
        loading: false,
        alertText: "Average selling price cannot be lower then 0.1",
        showAlert: true
      });
      return;
    }

    if (average_unit_costs < 0.1) {
      this.setState({
        loading: false,
        alertText: "Average unit costs cannot be lower then 0.1",
        showAlert: true
      });
      return;
    }

    const object_value = this.getObjectValue(data, "id");

    let target_round_number = parseInt(year.replace("year", ""), 10);
    if (isNaN(target_round_number)) {
      target_round_number = 0;
    }

    target_round_number = target_round_number - 1 + this.props.year_number1;

    this.getProjections(object_value)
      .send({
        average_selling_price: average_selling_price,
        average_unit_costs: average_unit_costs,
        capital_expenditures: this.getObjectValue(data, "capital_expenditures"),
        non_operating_expenses: this.getObjectValue(
          data,
          "non_operating_expenses"
        ),
        other_operating_costs: this.getObjectValue(
          data,
          "other_operating_costs"
        ),
        debt_borrowing: this.getObjectValue(data, "debt_borrowing"),
        units_sold: units_sold,
        sales_costs: this.getObjectValue(data, "sales_costs"),
        promo_costs: this.getObjectValue(data, "promo_costs"),
        rnd_costs: this.getObjectValue(data, "rnd_costs"),
        target_round_number: target_round_number
      })
      .then(res => {
        callback();
      })
      .catch(err => {
        if ("detail" in err.response.body) {
          const error = err.response.body["detail"];
          this.setState({
            loading: false,
            alertText: `Error: ${error} Object: ${object_value}`,
            showAlert: true
          });
        }

        logError(err, "ModalCeoProjections", "updateYear");
      });
  };

  /**
   * getUnits
   */
  getObject(year) {
    if (typeof year === "string") {
      year = year.replace("year", "");
      year = parseInt(year, 10);
      if (isNaN(year)) {
        year = 0;
      }
    }

    return this.state[`year${year}`];
  }

  getObjectValue(obj, key) {
    if (key in obj) {
      return obj[key];
    }

    const { currentRound, defaultValues } = this.state;
    if (currentRound === 1 && key in defaultValues) {
      return defaultValues[key];
    }

    return 0;
  }

  getUnits = year => this.getObjectValue(this.getObject(year), "units_sold");

  get unitsYear1() {
    return this.getUnits(1);
  }

  /**
   * getAvgSellingPrice
   */
  getAvgSellingPrice = year =>
    this.getObjectValue(this.getObject(year), "average_selling_price");

  /**
   * getTotalRevenues
   */
  getTotalRevenues = year =>
    this.getUnits(year) * this.getAvgSellingPrice(year);

  get totalRevenuesYear1() {
    return this.getTotalRevenues(1);
  }

  /**
   * getAvgUnitCosts
   */
  getAvgUnitCosts = year =>
    this.getObjectValue(this.getObject(year), "average_unit_costs");

  /**
   * getCostOfSales
   */
  getCostOfSales = year => {
    return this.getUnits(year) * this.getAvgUnitCosts(year);
  };
  get costOfSalesYear1() {
    return this.getCostOfSales(1);
  }

  /**
   * getGrossProfits
   */
  getGrossProfits = year =>
    this.getTotalRevenues(year) - this.getCostOfSales(year);

  get grossProfitsYear1() {
    return this.getGrossProfits(1);
  }

  /**
   * getTotalOperatingExpenses
   */
  getTotalOperatingExpenses = year =>
    this.getObjectValue(this.getObject(year), "other_operating_costs");

  /**
   * getOperatingProfits
   */
  getOperatingProfits = year =>
    this.getGrossProfits(year) - this.getTotalOperatingExpenses(year);

  /**
   * getNonOperatingExpenses
   */
  getNonOperatingExpenses = year =>
    this.getObjectValue(this.getObject(year), "non_operating_expenses");

  /**
   * getIncomeBeforeTaxes
   */
  getIncomeBeforeTaxes = year =>
    this.getOperatingProfits(year) - this.getNonOperatingExpenses(year);

  get incomeBeforeTaxesYear1() {
    return this.getIncomeBeforeTaxes(1);
  }

  /**
   * getTaxes
   */
  getTaxes = year => {
    return this.getIncomeBeforeTaxes(year) < 0
      ? 0
      : this.getIncomeBeforeTaxes(year) * 0.3 * -1;
  };

  /**
   * getNetIncome
   */
  getNetIncome = year =>
    this.getIncomeBeforeTaxes(year) - Math.abs(this.getTaxes(year));

  get netIncomeYear1() {
    return this.getNetIncome(1);
  }

  get inputProps() {
    return {
      type: "text",
      validations: {
        isNumeric: true
      },
      validationErrors: {
        isNumeric: "Only numeric values supported"
      },
      labelClassName: [{ "col-sm-3": false }, "hidden"],
      elementWrapperClassName: [{ "col-sm-9": false }, "custom-error-size"],
      rowClassName: ["form-group", "row", "projections-row"],
      validateOnSubmit: true,
      className: "",
      required: true
    };
  }

  render() {
    const { showModalState } = this.props;

    const roundedDiv = {
      backgroundColor: "#fff",
      padding: "2em",
      boxShadow: "rgba(0, 0, 0, 0.15) 0px 4px 8px",
      fontFamily: "Lato",
      width: "100%",
      fontSize: "16px",
      borderRadius: "3px"
    };

    const roundedDivWithMargin = {
      ...roundedDiv,
      marginTop: "2em"
    };

    const inlineBlock = showModalState ? null : "inline-block";

    return (
      <div className={inlineBlock}>
        <SweetAlert
          show={this.state.showAlert}
          title="Error"
          text={this.state.alertText}
          type="error"
          onConfirm={this.hideAlert}
        />

        {showModalState && (
          <fragment>
            <Form onValidSubmit={this.submitData}>
              <div className="text-center">
                {this.state.loading ? (
                  <button type="submit" className="btn btn-save" disabled>
                    Loading...
                  </button>
                ) : (
                  <ButtonsBlock>
                    <BlockTitle>CEO Projections</BlockTitle>
                    <Buttons>
                      <button
                        type="button"
                        className="btn btn-cancel"
                        disabled={this.props.tourMode}
                        onClick={this.hideModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-save"
                        id="ceo-projections-save-button"
                        disabled={this.isSaveDisabled}
                      >
                        Save
                      </button>
                    </Buttons>
                  </ButtonsBlock>
                )}
              </div>
              <div style={roundedDiv}>
                <BlockTitle>Revenues</BlockTitle>
                <TableRow>
                  <TableColumn />
                  <TableColumn align="center" fontSize="18px">
                    Year {this.props.year_number1}
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Units</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    {this.getInputElement(
                      this.props.year_number1,
                      "units_sold",
                      true,
                      99
                    )}
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Avg. Selling Price</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    {this.getInputElement(
                      this.props.year_number1,
                      "average_selling_price",
                      false,
                      100
                    )}
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Total Revenues</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    <TotalBlock>
                      <AbbreviatedMillionNumberFormat
                        value={this.totalRevenuesYear1}
                        prefix="$"
                        decimalPrecision={3}
                        addSpaceBeforeSuffix={true}
                        forceConvert={true}
                      />
                    </TotalBlock>
                  </TableColumn>
                </TableRow>
              </div>
              <div style={roundedDivWithMargin}>
                <BlockTitle>Gross Profits</BlockTitle>
                <TableRow>
                  <TableColumn />
                  <TableColumn align="center" fontSize="18px">
                    Year {this.props.year_number1}
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Units</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    <PriceInMillions
                      price={this.unitsYear1}
                      prefix=""
                      baseClassName=""
                      decimalPrecision={3}
                      addSpaceBeforeSuffix={true}
                    />
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Avg. Unit Costs</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    {this.getInputElement(
                      this.props.year_number1,
                      "average_unit_costs",
                      false,
                      100
                    )}
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Total Cost of Sales</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    <TotalBlock light={true}>
                      <AbbreviatedMillionNumberFormat
                        value={this.costOfSalesYear1}
                        prefix="$"
                        decimalPrecision={3}
                        addSpaceBeforeSuffix={true}
                        forceConvert={true}
                      />
                    </TotalBlock>
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Gross Profits</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    <TotalBlock>
                      <AbbreviatedMillionNumberFormat
                        value={this.grossProfitsYear1}
                        prefix="$"
                        decimalPrecision={3}
                        addSpaceBeforeSuffix={true}
                        forceConvert={true}
                      />
                    </TotalBlock>
                  </TableColumn>
                </TableRow>
              </div>
              <div style={roundedDivWithMargin}>
                <BlockTitle>Net Profits</BlockTitle>
                <TableRow>
                  <TableColumn />
                  <TableColumn align="center" fontSize="18px">
                    Year {this.props.year_number1}
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Other Expenses</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    {this.getInputElement(
                      this.props.year_number1,
                      "other_operating_costs",
                      true,
                      99
                    )}
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Income Before Taxes</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    <TotalBlock light={true}>
                      <AbbreviatedMillionNumberFormat
                        value={this.incomeBeforeTaxesYear1}
                        prefix="$"
                        decimalPrecision={3}
                        addSpaceBeforeSuffix={true}
                        forceConvert={true}
                      />
                    </TotalBlock>
                  </TableColumn>
                </TableRow>
                <TableRow marginTop="2rem">
                  <TableColumn align="right">Net Profits</TableColumn>
                  <TableColumn align="center" marginLeft="2rem">
                    <TotalBlock>
                      <AbbreviatedMillionNumberFormat
                        value={this.netIncomeYear1}
                        prefix="$"
                        decimalPrecision={3}
                        addSpaceBeforeSuffix={true}
                        forceConvert={true}
                      />
                    </TotalBlock>
                  </TableColumn>
                </TableRow>
              </div>
            </Form>
          </fragment>
        )}
      </div>
    );
  }
}

export default ProjectionsModal;



// WEBPACK FOOTER //
// ./src/components/ceo/decisions/projections-modal.js